window.Products.Clothing.Beanie = function() {
};
window.Products.Clothing.Beanie.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.Beanie.id = 42;
window.Products.Clothing.Beanie.slug = 'beanie';
window.Products.Clothing.Beanie.has_3d = true;
window.Products.Clothing.Beanie.dpi = 150;

window.Products.Clothing.Beanie.prototype.set3dProperties = function(modelViewer) {
    this.updateThreeTexture(modelViewer);
    modelViewer.camera.position.z =  1;
    modelViewer.initalCameraPosition.z = -1;

    this.liningColor('black', modelViewer);
};

window.Products.Clothing.Beanie.prototype.liningColor = function(color, modelViewer){
    var values = [];
    switch(color){
        case 'black':
            values = [0.1, 0.1, 0.1];
            break;
        case 'chocolate':
            values = [102/255, 83/255, 66/255];
            break;
        case 'electric-blue':
            values = [8/255, 130/255, 160/255];
            break;
        case 'pink':
            values = [0.68, 0.21, 0.52];
            break;
        case 'cherry':
            values = [60/255, 5/255, 10/255];
            break;
        case 'gray' : 
            values = [0.3, 0.3, 0.3];
            break;
    }
    modelViewer.object.children[0].material[0].color.r = values[0];
    modelViewer.object.children[0].material[0].color.g = values[1];
    modelViewer.object.children[0].material[0].color.b = values[2];
};

window.Products.Clothing.Beanie.prototype.setThreeControls = function(controls) {
    controls.minDistance = 1.8;
    controls.maxDistance = 2.5;
};

window.Products.Clothing.Beanie.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material[1].map = modelViewer.texture;
};